import { Component, Input, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';

import { AbstractAiDialogComponent } from '../../../../../Common/Dialogs/components/AbstractAIDialog/Abstract-AI-dialog.component';
import { FullProfileAnimationModel } from '../../../../../Core/Dialogs/models/full-profile-animation.model';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';
import { AEORecommendationModel } from '../../../../../api/distributions/model/aeo-recommendations.api.model';
import { DistributionService } from '../../../../../Common/TargetingShared/services/distribution.service';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';

@Component({
    selector: 'agpr-aeo-recommendations-dialog',
    templateUrl: './aeo-recommendations-dialog.component.html',
    styleUrls: ['./aeo-recommendations-dialog.component.scss'],
    standalone: false
})

export class AEORecommendationsDialogComponent extends AbstractAiDialogComponent implements OnInit {
    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly minPanelWidth = 1180;
    readonly maxPanelWidth = 1380;

    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;

    subscriptions: Subscription[] = [];

    hideSlideOverlay: boolean = false;
    loading: boolean = false;
    recommendations: AEORecommendationModel[] = [];
    selectedRecommendation: AEORecommendationModel;

    constructor(
        public coreDialogService: CoreDialogService,
        public distributionService: DistributionService,
        public messageService: MessageService
    ) {
        super(coreDialogService, 'AEORecommendations');
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.distributionService.getAEORecommendations().subscribe(
                recommendations => {
                    if (recommendations.length >= 0) {
                        this.recommendations = recommendations;
                        for (const recommendation of this.recommendations) {
                            recommendation.example = this.decodeEscapes(recommendation.example);
                        }
                        if (recommendations.length > 0) {
                            this.selectedRecommendation = this.recommendations[0];
                        }
                    }
                }
            ),
            this.distributionService.getAEORecommendationsLoading().subscribe(loading => this.loading = loading)
        );
    }

    copyGeneratedContent() {
        const type = 'text/html';
        const blob = new Blob([this.selectedRecommendation.example], { type });
        const data = [new ClipboardItem({ [type]: blob })];

        navigator.clipboard.write(data);

        this.messageService.add({
            severity: messageSeverityEnum.success,
            summary: 'Common.dialog.aiRefinement.copy.label',
            detail: 'Common.dialog.aiRefinement.copy.message',
        });
    }

    handleError(aiType?: string, httpStatusCode?: number) {
        throw new Error('Method not implemented.');
    }

    getRequestModel(aiType?: string) {
        throw new Error('Method not implemented.');
    }

    close() {
        this.closeDialog();
    }

    private decodeEscapes(str: string): string {
        return str.replace(/\\(.)/g, (_, ch) => {
            switch (ch) {
                case 'n': return '\n';
                case 't': return '\t';
                case 'r': return '\r';
                case '"': return '"';
                case '\'': return '\'';
                case '\\': return '\\';
                default: return ch; // leave unknown escapes as-is
            }
        });
    }
}
